<template>
  <div class="video-container" :class="[transcriptOpen?'vjs-transcription':'']">
    <div class="vjs-top-right-btns">
            <div v-if="displayLogo &&this.getSkinInfos?.info_logo " class="vjs-client-logo" :style="{ 'background-image': 'url(' + clientLogo + ')' }"></div>

      <div class="vjs-reload-live" v-if="isLive && liveStatus !== 1" v-on:click="reloadLive" v-html="SVG.RELOAD_LIVE_SVG">
      </div>
      <div v-if="privacyURL && this.getSkinInfos?.info_privacy_url" tabindex="0" class="vjs-privacy-btn" @click="handleRedirectPrivacy" v-html="SVG.PRIVACY_ICON_SVG">
      </div>
    </div>

    <div :class="[playlist ? 'video-player-playlist' : 'video-player']">
      <video ref="videoPlayer" :autoplay="autoplay" class="video-js" playsinline controls></video>

<TranscriptModal v-if="transcriptOpen" :currentTime="currentTime" :closeModal="closeTranscriptModal" :information="videoData" :player="player"/>
    </div>
    <PlayListVideos :playlist="playlist" :PlaylistItemClick="(index) => handlePlaylistItemClick(index)"
      :loopOption="loopOption" :currentIndex="currentIndex" :seekOption="seekOption" />
    <div v-if="activeLiveSubtitles" class="vjs-custom-text-track-display">
      <div style="position: absolute; inset: 0px">
        <div class="vjs-live-text-cue">
          <div class="vjs-live-subtitles">{{ currentSubtitle }}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import videojs from "video.js";
import { defineComponent } from "vue";
import { SVG } from "../components/utils/const";
import { handleUserKeyPress } from "../components/utils/keyboard";
import {
  onCreate,
  onPlay,
  onTimeUpdate,
  onSeek,
  onPause,
  onLoad,
  Ended,
  onFirstPlay,
} from "../components/utils/stats";
import { mapActions, mapGetters } from "vuex";

import en from "../i18n/en_US";
import fr from "../i18n/fr_FR";
import fr_player from "../locale/fr_FR.json";
import en_player from "../locale/en_US.json";
import { useRoute } from "vue-router";
import videojsqualityselector from "videojs-hls-quality-selector";
import axios from "axios";

import PlayListVideos from "../components/layout/Playlist/PlayListVideosLayout.vue";
import TranscriptModal from "../components/parts/TranscriptModal/TranscriptModal.vue";
import * as Utils from '../components/utils/richmedia';
import { SocketEvents } from "@/components/utils/socket/SocketEvents";

require("../plugins/spritePlugin");
require("videojs-vr");
require("videojs-contrib-quality-levels");
require("videojs-vr/dist/videojs-vr.css");
require("videojs-thumbnail-sprite");
require("@videojs/http-streaming");
require("videojs-landscape-fullscreen");

export default defineComponent({
  name: "VideoPlayer",
  components: {
    PlayListVideos,
TranscriptModal,

  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  props: [
    "autoplay",
    "videoData",
    "manifest",
    "panorama",
    "setPlayer",
    "rightClick",
    "leftClick",
    "showSettingsModal",
    "showSubtitlesModal",
    "showShareModal",
    "showDownloadModal",
    "isSubtitlesModalShown",
    "options",
    "isAllModalsClosed",
    "isLive",
    "cryptext",
    "isClassic",
    "loadSkin",
    "playlist",
    "loopOption",
    "seekOption",
    "showModalchaptre",
    "slides"
  ],
  data() {
    return {
            utils:Utils,
      SVG:SVG,
      player: {},
      indexSource: 0,
      clickedModal:false,
      paused: false,
      muted: true,
      mutedStorage: false,
      showActivateSound: true,
      adSource: false,
      errorMessage: "",
      localVD: {},
      addedButtonsId: [],
      playerSrc: {
        src: "",
        type: "",
      },
      locale: "fr",
      clientLogo: "",
      selectedSource: {},
      currentIndex: 0,
      previousM3U8Version: null,
      privacyURL: "",
      displayLogo:false,
      currentSubtitle: "",
      activeLiveSubtitles: true,
      liveStatus: -1,
      transcriptOpen:false,
      currentTime:0,
      loop:false,
      sprites: [],
      trackStream:-1,
      delay:0,
      indexingEvent:false,

    };
        },
  emits: ["adChanged", "closeModals", "get-playlist"],
  methods: {
    ...mapActions(["initializeSocketLive"]),
    sendSocketEvent(type, data,trackDelay) {
        const socket = this.getSocket; 
        if (socket?.readyState === WebSocket.OPEN) {
          if(!trackDelay){
            if(this.trackStream != data?.status){
            this.trackStream = data?.status;
            socket?.send(
                JSON.stringify({
                    type: type,
                    data: data
                })
            );
            this.reloadLive();
          }
          }else{
            socket?.send(
                JSON.stringify({
                    type: type,
                    data: data
                })
            );
          }
       
     
        }
    },
    hasChanged(newValue) {
      const hasChanged =
        JSON.stringify(newValue) !== JSON.stringify(this.localVD);
      this.localVD = newValue;
      return hasChanged;
    },
    handlePause() {
      if (!this.player.paused()) this.player.pause();
    },

    activateSound() {
      this.player.muted(!this.player.muted());
      this.showActivateSound = false;
    },
    handlePlaylistItemClick(index) {
      let playlistSources = this.playlist?.map((item) => item?.sources);
      const controlBar = this.player.controlBar;
      const videoJSElement = document.querySelector(".video-js");
      this.cleanError();
      this.$emit("closeModals");
      videoJSElement && videoJSElement?.classList?.add("vjs-updating");
      const playListOl = document.querySelector(".vjs-playlist-item-list");
      if (playListOl) {
        const childrenWithClass = playListOl.querySelectorAll(
          ".video-playlist-card"
        );
        childrenWithClass.forEach((elt, i) => {
          if (index === i) {
            elt.classList.add("vjs-selected");
          } else {
            elt.classList.remove("vjs-selected");
          }
          if (i === index + 1 && i <= childrenWithClass.length) {
            elt.classList.add("vjs-up-next");
          } else {
            elt.classList.remove("vjs-up-next");
          }
        });
      }

      if (this.addedButtonsId.length) {
        this.addedButtonsId.forEach((e) => {
          const item = controlBar.getChildById(e);
          item && controlBar.removeChild(item);
        });
      }
      this.$emit("get-playlist", playlistSources[index], true);
      this.addedButtonsId = [];
      controlBar.el().classList.add("vjs-has-updated-controls");
    },
    handleError(msg) {
      const loaderSpinner = document.querySelector(".vjs-loading-spinner");
      const playboutton = document.querySelector(".vjs-big-play-button");
      const modalError = document.querySelector(".vjs-modal-dialog-content");
      const Xboutton = document.querySelector(".vjs-error-display");
      const controlBar = document.querySelector(".vjs-control-bar");
      const playerComponents = document.querySelector("#components");
      const rmSlides = document.querySelector("#rm-slides");
      const thunmbnails=document.querySelector("#vjs-sliders-content");
      const overlayBtns = document.querySelector("#dark-overlay-buttons");
      this.showActivateSound=false
      loaderSpinner?.setAttribute("style", "display:none");
      playboutton?.setAttribute("style", "display:none");
      modalError?.setAttribute("style", "display:none");
      Xboutton?.setAttribute("style", "display:none");
      controlBar?.setAttribute("style", "display:none !important");
      let myDiv = document.createElement("div");
      playerComponents?.setAttribute("style", "display:none !important");
      rmSlides?.setAttribute("style", "display:none !important");
     thunmbnails?.setAttribute("style", "display:none !important");
          overlayBtns?.setAttribute("style", "display:none !important");

      myDiv.className = "vjs-error-live-msg-container";
      myDiv.innerHTML = SVG.WARNING_SVG;
      let myText = document.createElement("div");
      myText.innerText = msg;
      myText.className = "vjs-error-live-msg-text";
      myDiv.appendChild(myText);
      this.player.el().appendChild(myDiv);
    },
    cleanError() {
      const loaderSpinner = document.querySelector(".vjs-loading-spinner");
      const playButton = document.querySelector(".vjs-big-play-button");
      const modalError = document.querySelector(".vjs-modal-dialog-content");
      const xButton = document.querySelector(".vjs-error-display");
      const controlBar = document.querySelector(".vjs-control-bar");
      const playerComponents = document.querySelector("#components");
      const rmSlides = document.querySelector("#rm-slides");
      const thunmbnails=document.querySelector("#vjs-sliders-content");
      const overlayBtns = document.querySelector("#dark-overlay-buttons");

      const errorContainer = document.querySelector(
        ".vjs-error-live-msg-container"
      );

      if (loaderSpinner) {
        loaderSpinner.style.display = "";

        if (playButton) {
          playButton.style.display = "";
        }
        if (modalError) {
          modalError.style.display = "";
        }
        if (xButton) {
          xButton.style.display = "";
        }
        if (controlBar) {
          controlBar.style.display = "";
        }
        if (playerComponents) {
          playerComponents.style.display = "";
        }
        if (rmSlides) {
          rmSlides.style.display = "";
        }
             if (thunmbnails) {
         thunmbnails.style.display = "";
        }
                 if (overlayBtns) {
         overlayBtns.style.display = "";
        }
        if (errorContainer) {
          errorContainer.remove();
        }
      }
    },
    handleLiveError() {
      if (
        this.player.options_ &&
        this.player.options_.sources?.[this.indexSource]
      ) {
        const srcLive = this.player.options_.sources?.[this.indexSource]?.src;
        if (srcLive) {
          const vidPlayer = videojs("vjs_video_3");
          vidPlayer.src({
            src: this.player.options_.sources[this.indexSource].src,
          });
          this.indexSource++;
        } else {
          this.indexSource++;
          this.handleLiveError();
        }
      } else {
        this.indexSource = 0;
          if (this.liveStatus === -1) {
            if (this.videoData?.beforeLiveOptions?.countDownOptions?.time >= 0) {
              const comingDate = this.getLiveDate(this.videoData?.beforeLiveOptions?.countDownOptions?.time);
              this.handleError(this.$t("player.liveVideoWillStart", { date: comingDate?.date, hour: comingDate?.hour }));
            } else {
              this.handleError(this.$t("player.liveVideoIsStarting"));
            }
          } else if (this.liveStatus === 1 && this.trackStream !=0) {
            this.handleError(this.$t("player.liveVideoFinished"));
          } else if (this.liveStatus === 0 && this.trackStream !=1) {
            this.handleError(this.$t("player.liveVideoAir"));
          } else {
            this.handleError("");
          }
        
      }
    },
    async getSourceInfo() {
      try {
        this.fetchLiveStatus();
        const srcLive = this.player.options_.sources?.[this.indexSource]?.src;
        if (srcLive) {
          const response = await axios.get(srcLive);
          const newM3U8Content = response.data;
          if(newM3U8Content){
            this.sendSocketEvent(SocketEvents.liveStream, { status: 1 },false);
          }
          const versionMatch = newM3U8Content?.match(/#EXT-X-VERSION:(\d+)/);
          const versionValue =
            versionMatch && versionMatch.length >= 2 ? versionMatch[1] : null;
          if (this.previousM3U8Version && (versionValue !== this.previousM3U8Version)) {
            this.previousM3U8Version = versionValue;
            setTimeout(() => {
              this.reloadLive();
            }, 12000);
          }
          this.previousM3U8Version = versionValue;

        } else {
          this.indexSource = this.player.options_.sources.findIndex(obj => obj.src.trim() !== '');
        }

      } catch (error) {
        this.sendSocketEvent(SocketEvents.liveStream, { status: 0 },false);

      console.error("Error fetching M3U8 file:", error);
      }
    },
    reloadLive() {
      this.cleanError();
      setTimeout(() => {
        this.handleLiveError();
      }, 500);
    },
    async updatePlayer(VD, locale) {
      let techOrder = ['html5'];
      const translations = locale === "fr" ? fr_player : en_player;
      this.selectedSource = VD?.playerOptions.sources.find(
        (source) => source.selected
      );
      if (this.selectedSource && this.selectedSource.type === "video/youtube") {
        require("videojs-youtube");
        techOrder.push('youtube');
      }
      const isDVR=VD?.playerOptions?.isDvr !== undefined ? VD?.playerOptions?.isDvr:false;
      const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const isTextTrackDefault = VD?.playerOptions?.textTracks?.some(
        (t) => t.default
      );
      const updateTextTrack = VD?.playerOptions?.textTracks;
      if (!isTextTrackDefault && updateTextTrack?.length) {
        const videoJSElement = document.querySelector(".video-js");
        if (videoJSElement) {
          videoJSElement.classList.add("vjs-no-default-cc");
        }
        updateTextTrack[0].default = true;
        updateTextTrack[0].mode = "hidden";
      }

      this.player = videojs(
        this.$refs.videoPlayer,
        {
          ...VD?.playerOptions,
          liveTracker: {
            trackingThreshold: 0,
          },
          html5: {
            nativeTextTracks: isIos,
            nativeAudioTracks: isIos,
            nativeVideoTracks: isIos,
            vhs: {
              overrideNative: true,
            },
          },
          tracks: isIos ? [] : updateTextTrack,
          spriteUrl: VD?.playerOptions?.spriteUrl,
          liveui: isDVR,
          controls: true,
          textTrackSettings: true,
          techOrder: techOrder,
          language: locale,
          languages: {
            fr: fr_player,
            en: en_player,
          },
          plugins:{spritePlugin:this.generateSprites(VD?.playerOptions.spriteUrls)}
        },
        () => {
          const videoJSElement = document.querySelector(".video-js");
          videoJSElement && videoJSElement?.classList?.remove("vjs-updating");
          videojs.addLanguage(locale, translations);
          this.player.language(locale);
          const levels = this.player?.qualityLevels?.();
          levels.on('change', function() {

  const currentQuality = levels[levels.selectedIndex]
       const SettingsBtn = document.querySelector(
              ".customSettingsButton.vjs-settings-btn"
            );
             const HdIcon = document.querySelector(
              ".vjs-icon-hd"
            );
        if( SettingsBtn && currentQuality.height >= 720){
         
          SettingsBtn.classList.add("vjs-icon-hd")
        }else if(HdIcon){

           SettingsBtn.classList.remove("vjs-icon-hd")
        }else{

        SettingsBtn.classList.remove("vjs-icon-hd")
        }

});
          this.player.hlsQualitySelector = videojsqualityselector;
          this.player.hlsQualitySelector?.({
            displayCurrentQuality: true,
          });
          this.player.changeQuality = (i) => {
            levels.selectedIndex_ = i;
            levels.trigger({ type: "change", selectedIndex: i });
          };
          this.player.landscapeFullscreen({
            fullscreen: {
              enterOnRotate: true,
              exitOnRotate: true,
              alwaysInLandscapeMode: true,
              iOS: false,
            },
          });
          if(this.isLive && !isDVR){
            this.player.controlBar.removeChild(this.player.controlBar.currentTimeDisplay);
            this.player.controlBar.removeChild(this.player.controlBar.progressControl);
            this.player.controlBar.removeChild(this.player.controlBar.timeDivider);
          }

          if (!this.isClassic) {
            this.player.removeClass("vjs-classic-skin");
            this.player.addClass("vjs-custom-skin");
          } else {
            this.player.addClass("vjs-classic-skin");
            this.player.removeClass("vjs-custom-skin");
          }
        }
      );
      if (!this.isClassic) {
        if (this.gethasInfo?.chapters?.length > 0 &&
          (!this.gethasInfo.isBo || (this.gethasInfo.isBo && this.gethasInfo?.chapters?.length > 0))
          ) {
          // <---------Start Menu Button--------->
          const menuButton = this.player.controlBar.addChild("button");
          menuButton.addClass("customMenuButton");
          menuButton.on(["click", "touchend"], (event) => {
            event.preventDefault();
            this.showModalchaptre();
          });
          menuButton.addClass("hoverable");

          const fullscreenToggle = this.player.controlBar
            .getChild("fullscreenToggle")
            ?.el();
          this.player.controlBar
            .el()
            .insertBefore(menuButton.el(), fullscreenToggle || null);

          menuButton.controlText(this.$t("buttons.menu"));
          const menuButtonDom = menuButton.el();
          menuButtonDom.innerHTML = SVG.MENU_SVG;
          menuButtonDom.classList.add("customMenuButton");
          
          this.addedButtonsId.push(menuButton.id());
        }
        // <---------End Menu Button--------->
          
          
                  /** SETTINGS BTN */
                  const existingSettingsButton = this.player.controlBar
                    .el()
                    .querySelector(".customSettingsButton");
                  if (!existingSettingsButton) {
                    const settingsButton = this.player.controlBar.addChild("button");
                    settingsButton.addClass("customSettingsButton");
                    settingsButton.on(["click", "touchend"], (event) => {
                      event.preventDefault();
                      this.showSettingsModal?.();
                      settingsButton.blur();
                    });
                    this.player.controlBar
                      .el()
                      .insertBefore(
                        settingsButton.el(),
                        this.player.controlBar.getChild("fullscreenToggle")?.el() || null
                      );
          
                    let settingsButtonDom = settingsButton.el();
                    settingsButtonDom.classList.add("vjs-settings-btn");
                    settingsButtonDom.innerHTML = SVG.SETTING_SVG;
                    settingsButton.controlText(this.$t("buttons.settings"));
                  }
                  /** END SETTINGS BTN */
                  
     

          
        if (window.process.env.PLAYER_STOP_ACTION && !this.isLive ) {
          let stopBtnExists = this.player.controlBar.getChild("vjs-stop-btn");

          if (!stopBtnExists ) {
            // <---------Start Stop Button--------->
            let StopBtn = this.player.controlBar.addChild("button", {}, 0);
            StopBtn.addClass("vjs-stop-btn");
            StopBtn.el().innerHTML = SVG.STOP_SVG;
            StopBtn.controlText(this.$t("buttons.stop"));
            StopBtn.on(["click", "touchend"], () => {
              this.player.currentTime(0);
              StopBtn.blur();
            });
            this.addedButtonsId.push(StopBtn.id());
            // <---------End Stop Button--------->
          }
        }
        if (window.process.env.PLAYER_PIP_ACTION ) {
          const PipButton = document.querySelector(
            ".vjs-picture-in-picture-control"
          );
          if (PipButton ) {
            PipButton.style.display = "block";
          }
        }

        // <---------Start Download Transcription Button--------->
        const settingsComponent = this.player.controlBar
          .el()
          .querySelector(".customSettingsButton");
        if (VD?.playerOptions?.textTracks?.length) {
          const downlaodSubsButton = this.player.controlBar.addChild("button");
          downlaodSubsButton.on(["click", "touchend"], (event) => {
            event.preventDefault();

            this.transcriptOpen=!this.transcriptOpen
          });
          this.player.controlBar
            .el()
            .insertBefore(downlaodSubsButton.el(), settingsComponent || null);
          downlaodSubsButton.controlText("Transcription");
          const subsButtonDom = downlaodSubsButton.el();
          this.addedButtonsId.push(downlaodSubsButton.id());
          subsButtonDom.innerHTML = SVG.TRANSCRIPT_SVG;
          subsButtonDom.classList.add("customDownlaodSubsButton");
        }
        // <---------End Download Transcription Button--------->
        // <---------Add Previous / Next Buttons--------->
        if (VD?.playListOptions?.sources?.length) {
          const volumePanel = this.player?.controlBar
            ?.getChild("volumePanel")
            ?.el();



const previousButton = this.player.controlBar.addChild("button");
 previousButton.addClass("vjs-prev-button");
          previousButton.controlText(this.$t("player.previous"));
          if (volumePanel) {
            volumePanel.parentNode?.insertBefore(previousButton.el(), volumePanel);
          }
            previousButton.on(["click", "touchend"], (e) => {
            e.preventDefault();
            this.player.playlist?.previous?.();
            let index = this.playlist.findIndex((item) => item.selected);
            if (index > 0) {
              this.handlePlaylistItemClick(index - 1);
            }
          });
          this.addedButtonsId.push(previousButton.id());

    const nextButton = this.player.controlBar.addChild("button");
nextButton.addClass("vjs-next-button");
  nextButton.controlText(this.$t("player.next"));
if (volumePanel) {
    volumePanel.parentNode.insertBefore(nextButton.el(), volumePanel);
} 
         nextButton.on(["click", "touchend"], (e) => {
            e.preventDefault();
            this.player.playlist?.next?.();
            let index = this.playlist.findIndex((item) => item.selected);
            if (index < this.playlist.length - 1) {
              this.handlePlaylistItemClick(index + 1);
            } else if (this.localVD?.playListOptions?.loop) {
              this.handlePlaylistItemClick(0);
            }
          });
          this.addedButtonsId.push(nextButton.id());
        }
        // <---------End Previous / Next Buttons--------->
        // <---------Start AD Button--------->
        if (VD?.adSource) {
          var buttonAd = this.player.controlBar.addChild("button");
          buttonAd.on(["click", "touchend"], (event) => {
            event.preventDefault();
            const textTrackDisplay = document.querySelector(
              ".vjs-text-track-display"
            );
            const vidPlayer = videojs("vjs_video_3");
            if (!this.adSource) {
              vidPlayer.src({ src: VD?.adSource });
              textTrackDisplay.style.display = "none";
              buttonAd.el().classList.add("active");
              vidPlayer.load();
              vidPlayer.play();
              this.adSource = true;
              this.$emit("adChanged", true);
            } else {
              textTrackDisplay.style.display = "block";
              buttonAd.el().classList.remove("active");
              vidPlayer.src({
                src: VD?.playerOptions.sources[0].src,
              });
              vidPlayer.load();
              vidPlayer.play();
              this.adSource = false;
              this.$emit("adChanged", false);
            }
          });

          this.player.controlBar
            .el()
            .insertBefore(buttonAd.el(), settingsComponent || null);
          buttonAd.controlText(this.$t("buttons.AD"));
          buttonAd.el().innerHTML = SVG.AD_SVG;
          buttonAd.addClass("adSourceButton");
          this.addedButtonsId.push(buttonAd.id());
        }
        // <---------End AD Button--------->

        // <---------Start Subtitles Button--------->
        if (VD?.playerOptions?.textTracks?.length ) {
          const subsButton = this.player.controlBar.addChild("button");
          const modalClass = document.querySelector(
            ".vjs-modal-dialog.vjs-text-track-settings"
          );
          subsButton.on(["click", "touchend"], (event) => {
            event.preventDefault();
            this.showSubtitlesModal();
            if (modalClass) {
              modalClass.classList.add("vjs-hidden");
            }
            subsButton.blur();
          });

          this.player.controlBar
            .el()
            .insertBefore(subsButton.el(), settingsComponent || null);
          subsButton.controlText(this.$t("buttons.subtitlesOrCc"));
          this.addedButtonsId.push(subsButton.id());
          const subsButtonDom = subsButton.el();
          subsButtonDom.classList.add("customSubsButton");
          const selectedCC =  VD?.playerOptions?.textTracks?.some((f) => f.selected);
          if (selectedCC) {
                        subsButtonDom.innerHTML = SVG.CLOSED_CAPTIONS_ON;
          } else {
                        subsButtonDom.innerHTML = SVG.CLOSED_CAPTIONS_OFF;
            }
        }
        // <---------End Subtitles Button--------->
                    // <---------Start Extract Button--------->
if(
  this.getSkinInfos?.control_extract && !this.gethasInfo.isBo
){
  const extractButton = this.player.controlBar.addChild("button");
  
  extractButton.on(["click", "touchend"], (event) => {
    event.preventDefault();
    this.handleExtractPlayer();

    extractButton.blur();
  });

  this.player.controlBar
    .el()
    .insertBefore(extractButton.el(), settingsComponent || null);
    extractButton.controlText(this.$t("buttons.extractVideo"));
  this.addedButtonsId.push(extractButton.id());
  const subsButtonDom = extractButton.el();
  subsButtonDom.classList.add("customExtractButton");
  subsButtonDom.innerHTML = SVG.EXTRACT_VIDEO;



}         

// <---------End Extract Button--------->

        // <---------Start LIVE Subtitles Button--------->
        if (this.isLive && this.videoData?.infoOptions?.fo_subtitles) {
          const liveSubsButton = this.player.controlBar.addChild("button");
          this.player.controlBar
            .el()
            .insertBefore(liveSubsButton.el(), settingsComponent || null);
          liveSubsButton.controlText(this.$t("buttons.liveSubtitlesOrCc"));
          this.addedButtonsId.push(liveSubsButton.id());
          const liveSubsButtonDom = liveSubsButton.el();
          liveSubsButtonDom.innerHTML = SVG.LIVE_CLOSED_CAPTIONS;
          liveSubsButtonDom.classList.add("customLiveSubsButton", "active");
          liveSubsButton.on(["click", "touchend"], (event) => {
            event.preventDefault();
            this.activeLiveSubtitles = !this.activeLiveSubtitles;
            if (this.activeLiveSubtitles) {
              liveSubsButtonDom.classList.add("active");
            } else {
              liveSubsButtonDom.classList.remove("active");
            }
          });



        }
        // <---------End LIVE Subtitles Button--------->

        // <---------Start Download Button--------->
        if (!this.isLive && VD?.downloadOptions) {
          const downloadButton = this.player.controlBar.addChild("button");
          if (
            VD?.infoOptions?.list_lang &&
            VD?.infoOptions?.list_lang?.length
          ) {
            downloadButton.on(["click", "touchend"], async () => {
              this.showDownloadModal();
            });
          } else {
            downloadButton.on(["click", "touchend"], async () => {
              axios
                .get(`https:${window.process?.env.URL_LIVE_INTRANET === window.location.hostname ? "//" + window.process?.env.URL_LIVE_INTRANET + "/player" : window.process?.env?.API_PLAYER}/api/video/download/${this.cryptext}`, {
                  headers: {
                    authorization: `Bearer ${window.process?.env?.API_TOKEN}`,
                  },
                })
                .then((response) => {
                  let fileUrl = response?.data?.data?.file;
                  if (fileUrl) {
                    window.open(fileUrl, "_blank");
                  }
                })
                .catch((e) => {
                  console.log("error download", e);
                });
            });
          }

          this.player.controlBar
            .el()
            .insertBefore(downloadButton.el(), settingsComponent || null);
          downloadButton.controlText(this.$t("buttons.download"));
          const downloadButtonDom = downloadButton.el();
          this.addedButtonsId.push(downloadButton.id());
          downloadButtonDom.innerHTML =
            SVG.DOWNLOAD_SVG;
          downloadButtonDom.classList.add("customDownloadButton");
        }

        // <---------End Download Button--------->
        // <---------Start SHARE Button--------->
        if (
          VD?.shareOptions !== undefined &&
          (VD?.shareOptions?.length || Object.keys(VD?.shareOptions)?.length)
        ) {
          const shareButton = this.player.controlBar.addChild("button");
          shareButton.on(["click", "touchend"], async (event) => {
            event.preventDefault();
            this.showShareModal();
            shareButton.blur();
          });
          this.player.controlBar
            .el()
            .insertBefore(shareButton.el(), settingsComponent || null);

          shareButton.controlText(this.$t("buttons.share"));
          const subsButtonDom = shareButton.el();
          this.addedButtonsId.push(shareButton.id());
          subsButtonDom.innerHTML = SVG.SHARE_SVG;
          subsButtonDom.classList.add("customShareButton");
        }
        // <---------End SHARE Button--------->
        if (this.panorama) {
          this.player.vr?.({
            projection: "360",
            motionControls: true,
          });
        }
      }
      // <---------Start Config VOlume Button--------->
      const volumePanel = document.querySelector(
        ".vjs-volume-panel.vjs-control"
      );
      const volumeControl = document.querySelector(
        ".vjs-volume-control.vjs-control"
      );
      if (volumeControl && volumePanel) {
        const hoverHandler = () => {
          volumePanel.classList.add("vjs-slider-active");
          volumeControl.classList.add("vjs-slider-active");
        };
        const unhoverHandler = () => {
          volumePanel.classList.remove("vjs-slider-active");
          volumeControl.classList.remove("vjs-slider-active");
        };
        volumePanel.addEventListener("mouseover", hoverHandler);
        volumePanel.addEventListener("mouseout", unhoverHandler);
      }
          

      // <---------End Config VOlume Button--------->
     

      this.player.stats_res = VD?.statsOptions;
      this.player.videoTitle = VD?.titleOptions
        ? VD?.titleOptions
        : VD?.playerOptions?.streamName;
      this.player.isBo = VD?.paramsOptions?.isBO;
      this.player.currentT = 0;
      this.player.HasSeeked = false;
      this.player.seekCount = 0;
      this.player.pauseCount = 0;
      this.player.manifest = this.manifest;
      onCreate(this.player);
      onLoad(this.player);
      this.player.on("play", async () => {
        this.player.controlBar.addClass("active");
        const rewindBtn = document.createElement("button");
        const forwardBtn = document.createElement("button");
        rewindBtn.classList.add("disable-style");
        forwardBtn.classList.add("disable-style");
      });
      // this.player.playbackRates([0.25, 0.5, 0.75, 1, 1.25, 1.5, 2]);

      this.player.on("loadedmetadata", async () => {

        onFirstPlay(this.player);
        onPlay(this.player);
        onTimeUpdate(this.player);
        onSeek(this.player);
        onPause(this.player);
        Ended(this.player);
      });

      this.player.on("ready", async () => {
          if(!this.isLive){
          this.loadSkin();
          if(this.videoData?.rmOptions?.slides?.length){
            this.utils.updateOverlayButtonsPosition();
      this.utils.updateBigPlayButton();
     this.utils.fixThumbnailHeight();
 window.addEventListener('resize', () => {
      this.utils.updateOverlayButtonsPosition();
      this.utils.updateBigPlayButton();
     this.utils.fixThumbnailHeight();
    
    });
          }

          

          }
        if (this.isLive) {
          this.player.tech().on("retryplaylist", () => {
            this.reloadLive();
          });
        }
                this.player.loop(this.loop);
        this.setPlayer?.(this.$refs.videoPlayer, this.player);

        /** AUTOPLAY LOGIC **/
        if (this.isLive && this.autoplay) {
          this.player.muted(true);
          this.player.on("volumechange", () => {
              this.muted = this.player.muted();
            });
        } else {
          try {
            this.mutedStorage =
              localStorage.getItem("uep-player-muted") != "-1";
            const x = localStorage.getItem("uep-player-volume");
            if (x) {
              this.player.volume(+x);
            }
            this.player.on("volumechange", () => {
                            const volumePlayer =
                Math.round(this.player.volume() * 10) / 10 + "";
              if (this.player.muted()) {
                localStorage.setItem("uep-player-muted", "1");
              } else {
                localStorage.setItem("uep-player-volume", volumePlayer);
                localStorage.setItem("uep-player-muted", "-1");
              }

              this.muted = this.player.muted();
            });
          } catch (e) {
            this.player.on("volumechange", () => {
              this.muted = this.player.muted();
                          });
          }

          if (this.autoplay) {
            this.player.muted(true);
          }else{
            this.muted = this.player.muted();


          }
        }

        /**
         * KEYBOARD
         */
        window.addEventListener("keydown", (e) => {
          if(e.target.localName!=="input"){
          if (e.keyCode === 79 && !this.isClassic) {
            this.showSettingsModal?.();
          } else if (e.keyCode === 27) {
            this.$emit("closeModals");
          } else {
            handleUserKeyPress(e, this.player,this.isLive);
          }
          }

        });
        /**
         * END KEYBOARD
         */
      });
      let fetchedSegments = new Map();
      let loggedDelays = new Set(); // add this at component scope if needed

      this.player.on("timeupdate", async () => {
        if(this.isLive && this.indexingEvent){
          let tracks = this.player.textTracks();
          let segmentMetadataTrack;
          for (let i = 0; i < tracks.length; i++) {
            if (tracks[i].label === 'segment-metadata') {
              segmentMetadataTrack = tracks[i];
              break;
            }
          }
          const cue = segmentMetadataTrack?.activeCues?.[0];
    const segmentUri = cue?.value?.uri;
    const programDateTime = cue?.value?.dateTimeString;

          if (segmentUri && programDateTime && !loggedDelays.has(segmentUri)) {
            loggedDelays.add(segmentUri); // mark this segment as logged

const segmentProgramTime = new Date(programDateTime).getTime();
const now = Date.now();

const rawDelay = (now - segmentProgramTime) / 1000;

this.delay=rawDelay.toFixed(2);
}
        }
        if (this.isLive && this.videoData?.infoOptions?.fo_subtitles && this.activeLiveSubtitles) {
          let tracks = this.player.textTracks();
          let segmentMetadataTrack;
          for (let i = 0; i < tracks.length; i++) {
            if (tracks[i].label === 'segment-metadata') {
              segmentMetadataTrack = tracks[i];
            }
          }
          if (segmentMetadataTrack && segmentMetadataTrack.activeCues[0]?.value?.uri) {
      if (!fetchedSegments.has(segmentMetadataTrack.activeCues[0]?.value?.uri)) {
              fetchedSegments.set(segmentMetadataTrack.activeCues[0]?.value?.uri, '');
              axios.get(
                window.process?.env?.URL_LIVE_INTRANET === window.location.hostname ? "//" + window.process?.env.URL_LIVE_INTRANET : window.process?.env?.API_PLAYER + "/speech-to-text",
                {
                  params: {
                    url: segmentMetadataTrack.activeCues[0]?.value?.uri,
                  },
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                  },
                }
              ).then(response => {

        const transcription = response?.data?.results && response?.data?.results.length?response?.data?.results
  .map(result => result?.alternatives[0]?.transcript || "").filter((el)=>el).join(''):'';


                this.currentSubtitle = transcription;

                if (transcription) {
                  fetchedSegments.set(segmentMetadataTrack.activeCues[0]?.value?.uri, transcription);
                }
              }).catch(error => {
                console.error('Axios error:', error);
              });
            } else if(fetchedSegments.get(segmentMetadataTrack.activeCues[0]?.value?.uri)) {
              this.currentSubtitle = fetchedSegments.get(segmentMetadataTrack.activeCues[0]?.value?.uri);
            }


          }
        }
        window.parent.postMessage(
          {
            info: "moveToNextChapSld",
            value: [this.player.currentTime()],
          },
          "*"
        );
        window.postMessage(
          {
            info: "moveToNextChapSld",
            value: [this.player.currentTime()],
          },
          "*"
        );
        this.currentTime=this.player.currentTime();
        if(this.getExtractInfos){
          if((this.getExtractInfos?.end && this.player.currentTime()>this.getExtractInfos?.end*this.player.duration()/100) || this.player.currentTime()<this.getExtractInfos?.start*this.player.duration()/100){
            const timeToStart = this.getExtractInfos?.start*this.player.duration()/100;
            this.player.currentTime(timeToStart)

          }
        }

      });
      let playerVid = videojs(document.getElementById("vjs_video_3"));
      const indexSRC = VD?.playerOptions?.sources.findIndex(obj => obj.src.trim() !== '');
      playerVid.src({
        src: VD?.playerOptions?.sources[indexSRC]?.src,
        type: VD?.playerOptions?.sources[indexSRC]?.type,
      });
      this.player.playlist?.currentItem?.();
      this.player.playlist?.autoadvance?.(0);
      this.player.playlist?.repeat?.(false);
      /**
       * Handle context menu
       */
      this.player.on("contextmenu", (e) => {
        this.rightClick?.(e);
        this.clickedModal=true
      });
      this.player.on("touchstart", (e) => {
        if (e.target.nodeName === "VIDEO") {
          if (this.player.paused()) {
            this.player.play();
          } else {
            this.player.pause();
          }
        }
      });
      this.player.on("click", (e) => {
        if( this.clickedModal){
        this.leftClick?.(e)

        }
        const videoContainer = document.getElementById("vjs_video_3");
        if (
          !this.player.paused() &&
          this.player.currentTime() > 0 &&
          !this.paused &&
          !this.panorama &&
          e.target === videoContainer &&
          !this.isAllModalsClosed
        ) {
          this.player.pause();
          this.paused = true;
        } else {
          this.paused = false;
        }
      });

      // <--------- Start Pause Player Button--------->
          const paused = document.querySelector(".video-js");
      const pauseBtn = document.createElement("button");
      const iconPlaceholder=document.createElement("span");
      iconPlaceholder.className="vjs-icon-placeholder"
      pauseBtn.classList = "vjs-big-play-button vjs-big-pause-button";
      pauseBtn.title=this.$t("player.videoPause");
      pauseBtn.appendChild(iconPlaceholder)
      paused.appendChild(pauseBtn);
      pauseBtn.onclick = () => {
        this.player.paused() ? this.player.play() : this.player.pause();
      };

      
      

      
    

      // <--------- End Pause Player Button--------->

      const rewindBtn = document.createElement("button");
      const forwardBtn = document.createElement("button");
      this.player.on("pause", async () => {
        rewindBtn.classList.remove("disable-style");
        forwardBtn.classList.remove("disable-style");
        const isMobileDevice = window.matchMedia("(pointer:coarse)").matches;
        if (isMobileDevice && this.player.paused()) {
          rewindBtn.className = "vjs-rewind-button vjs-big-play-button";
          forwardBtn.className = "vjs-forward-button vjs-big-play-button";
          rewindBtn.innerHTML = SVG.REWIND;
          forwardBtn.innerHTML = SVG.FORWARD;
          rewindBtn.setAttribute("id", "rewind-btn");
          forwardBtn.setAttribute("id", "forward-btn");

          rewindBtn.onclick = () => {
            var currentTime = this.player.currentTime();

            if (currentTime - 10 >= 0) {
              this.player.currentTime(currentTime - 10);
            } else {
              this.player.currentTime(0);
            }
          };
          forwardBtn.onclick = () => {
            var currentTime = this.player.currentTime();
            if (currentTime + 10 <= this.player.duration()) {
              this.player.currentTime(currentTime + 10);
            } else {
              this.player.currentTime(this.player.duration());
            }
          };
          this.player.el().appendChild(rewindBtn);
          this.player.el().appendChild(forwardBtn);
        }
      });

      this.player.on("ended", async () => {
        if (this.loopOption) {
          this.playNextVideo();
        } else {
          this.nextOne();
          window.parent.postMessage(
            {
              info: "endedPlayer",
              value: true,
            },
            "*"
          );
          window.postMessage(
            {
              info: "endedPlayer",
              value: true,
            },
            "*"
          );
          rewindBtn.remove();
          forwardBtn.remove();
        }
      });

      /**
       * Handle left click
       */
    },
    playNextVideo() {
      if (this.loopOption) {
        const selectedIndex = this.playlist.findIndex(
          (video) => video.selected
        );
        const nextIndex = (selectedIndex + 1) % this.playlist.length;
        this.currentIndex = nextIndex;
        this.handlePlaylistItemClick(nextIndex);
      }
    },
    nextOne() {
      if(this.playlist){
              const selectedIndex = this.playlist.findIndex((video) => video.selected);
      const lastIndex = this.playlist.length - 1;

      if (selectedIndex === lastIndex) {
        return;
      }

      const nextIndex = selectedIndex + 1;
      this.currentIndex = nextIndex;
      this.handlePlaylistItemClick(nextIndex);

      }
    },
    handleRedirectPrivacy() {
      window.open(window.process?.env?.URL_PRIVACY_POLICY, "_blank");
    },
    getLiveStatusValue(str) {
      switch (str?.toUpperCase()) {
        case "UPCOMING":
          return -1;
        case "ONGOING":
          return 0
        case "ENDED":
          return 1
        default:
          return -1
      }
    },
    getLiveDate(seconds) {
      let now = new Date();
      now.setSeconds(now.getSeconds() + seconds);
      let day = now.getDate().toString().padStart(2, '0');
      let month = (now.getMonth() + 1).toString().padStart(2, '0');
      let year = now.getFullYear();
      let hours = now.getHours().toString().padStart(2, '0');
      let minutes = now.getMinutes().toString().padStart(2, '0');
      let formattedDate = `${day}/${month}/${year}`;
      let formattedHour = `${hours}:${minutes}`
      return { date: formattedDate, hour: formattedHour };
    },
    fetchLiveStatus() {
      axios
        .get(
          `https:${window.process?.env.URL_LIVE_INTRANET === window.location.hostname ? "//" + window.process?.env.URL_LIVE_INTRANET + "/player" : window.process?.env?.API_PLAYER}/api/video/getLiveStatus/${this.videoData?.playerOptions?.liveId}`,
          {
            headers: {
              authorization: `Bearer ${window.process?.env?.API_TOKEN}`,
            },
            params: {
              isEvent: this.videoData?.infoOptions?.is_event
            }
          }
        )
        .then((resp) => {
          this.liveStatus = this.getLiveStatusValue(resp.data?.status);
        }).catch((err) => {
          console.log('ERROR: GETTING LIVE STATUS', err)
        })
    },
    closeTranscriptModal(){
      this.transcriptOpen=false;
    },
     insertSpriteNumber(url, spriteNumber) {
    let lastIndex = url.lastIndexOf(".");
    if (lastIndex !== -1) {
        let baseUrl = url.slice(0, lastIndex); 
        return `${baseUrl}${spriteNumber}.jpg`;
    } else {
        return url;
    }
},
    generateSprites(spriteObject){
      if (!spriteObject ||!spriteObject.extension || 
        !spriteObject.spriteBaseName || 
        typeof spriteObject.spriteFileCount !== 'number' || 
        spriteObject.spriteFileCount <= 0 || 
        !spriteObject.spritePathS3) {
        return []; 
    }

    const sprites = Array.from({ length: spriteObject.spriteFileCount }, (_, index) => {
        const fileNumber = String(index + 1).padStart(3, '0'); 
        return `${spriteObject.spritePathS3}/${spriteObject.spriteBaseName}_${fileNumber}.${spriteObject.extension}`;
    });
    
    return sprites;
    },

    handleExtractPlayer(){
      const duration = this.player.duration();
  
  window.parent.postMessage({ info: 'extractPlayer', value:duration }, '*');
    },
    handleStartEndExtract(data){
      const timeToStart = data?.start*this.player.duration()/100;
      this.player.currentTime(timeToStart);
    }


  },
  computed: {
    ...mapGetters(["setVideoInfos", "gethasInfo","getSkinInfos" , "getSkinInfos" ,"getSocket","getExtractInfos"]),

  },
  created() {
    const route = useRoute();
    this.locale = route?.query.lang || "fr";
    this.privacyURL = window.process?.env?.URL_PRIVACY_POLICY;
    this.displayLogo = window.process.env.DISPLAY_PLAYER_LOGO !== undefined ? window.process.env.DISPLAY_PLAYER_LOGO : false;
    this.loop = route?.query !== undefined && route?.query.loop !== undefined ? route?.query.loop === "1" : false;

  },
  async mounted() {
    const queryParams = this.$route.query;
    this.indexingEvent = queryParams.indexing ==="1";

    videojs.log.level('off');
    this.updatePlayer(this.videoData, this.locale);
    if (this.isLive) {
      this.initializeSocketLive(this.videoData?.playerOptions?.liveId);
   
      if (this.videoData?.infoOptions?.fo_subtitles) {
        const mainVideoContainer = document.getElementById("vjs_video_3");
        const customLiveTextTrack = document.querySelector(".vjs-custom-text-track-display");
        mainVideoContainer?.appendChild(customLiveTextTrack);
      }
      this.liveStatus = this.videoData?.playerOptions?.status;
      setInterval(() => {
        if (this.liveStatus !== 1) {
          this.getSourceInfo();
        }
      }, 5000);
      this.player.on("error", () => {
        console.log('PLAYER ERREOR',this.player.error())
        this.previousM3U8Version = -1;
        this.handleLiveError();
        this.player.errorDisplay.hide();
        
      });
    } else {
      this.player.on("error", () => {
        const error = this.player.error();
      
        const errorCode = error?.code;
        const errorMessage = error?.message;
        if (errorCode === 4 && errorMessage.includes("No compatible source was found for this media")) {
          this.handleError(this.$t("player.sourceVide"));
        } else if (errorCode === 4) {
          this.handleError(this.$t("player.srcprocessed"));
        } else if (errorCode === 3) {
          this.player.errorDisplay.hide();
        } else {
          console.error('Error details:', error);
        }
      });

    }
    this.clientLogo = this.videoData?.logo;
    if (!this.seekOption) {
      const videoContainer = document.getElementById("vjs_video_3");
      let isSelecting = false;
      let seekStartPosition = 0;

      videoContainer.addEventListener("mousedown", (event) => {
        if (event.target === videoContainer && this.player.paused()) {
          isSelecting = true;
          seekStartPosition = this.player.currentTime();
        }
      });

      videoContainer.addEventListener("mouseup", () => {
        if (isSelecting) {
          isSelecting = false;
          const seekEndPosition = this.player.currentTime();
          const seekDuration = seekEndPosition - seekStartPosition;
          if (seekDuration > 0) {
            this.player.currentTime(seekEndPosition);
          }
        }
      });
      const seekBar = videoContainer.querySelector(".vjs-progress-control");
      seekBar.addEventListener("click", (event) => {
        event.stopPropagation();
      });
      seekBar.style.pointerEvents = "none";
    }
  },
  watch: {
    videoData: {
      handler(newValue) {
        if (this.hasChanged(newValue)) {
          const controlBar = this.player.controlBar;
          if (this.addedButtonsId.length) {
            this.addedButtonsId.forEach((e) => {
              const item = controlBar.getChildById(e);
              item && controlBar.removeChild(item);
            });
          }
          this.updatePlayer(newValue, this.locale);
          if (newValue.playerOptions.textTracks) {
            let playerVideoAD = videojs(document.getElementById("vjs_video_3"));
            let tracks = playerVideoAD.textTracks();
            for (let i = 0; i < tracks.length; i++) {
              var track = tracks[i];
              if (track.kind === "captions" || track.kind === "metadata") {
                track.mode = "hidden";
              }
            }
            (newValue.playerOptions.textTracks || []).forEach((track) => {
              track.mode = "showing";
              playerVideoAD.addRemoteTextTrack(track, false);
            });
          }
          if (newValue.playerOptions.spriteUrl) {
            const spriteElement = document.querySelector(
              ".vjs-progress-control.vjs-control  .vjs-progress-holder .vjs-mouse-display .vjs-time-tooltip"
            );
            const existingStyleElement =
              document.getElementById("custom-bg-sprite");
            if (existingStyleElement) {
              existingStyleElement.remove();
            }
            const styleElement = document.createElement("style");
            styleElement.id = "custom-bg-sprite";
            const classStyles = `
  .vjs-sprite-image {
    background-image: url(${newValue.playerOptions.spriteUrl})!important;
  }
`;

            styleElement.textContent = classStyles;
            document.head.appendChild(styleElement);
            spriteElement && spriteElement.classList.add("vjs-sprite-image");
          }
        }
      },
    },
    liveStatus: {
      handler(newValue) {
        if (newValue !== this.videoData?.playerOptions?.status) {
          this.reloadLive();
        }
      }
    },
    getExtractInfos:{
      handler(newValue){
        this.handleStartEndExtract(newValue);
      }
    },
    delay:{
      handler(newValue){
        this.sendSocketEvent(SocketEvents.trackEventDelay, { delay: newValue },true);

      }
    }
     },
  beforeUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  },
});
</script>
<style>
.customExtractButton,
.customSubsButton,
.adSourceButton,
.customDownlaodSubsButton,
.customLiveSubsButton,
.customDownloadButton,
.customShareButton,
.vjs-settings-btn,
.vjs-stop-btn {
  cursor: pointer !important;
}

.vjs-stop-btn svg{
  width:1.25em!important;
  height: 1.25em!important;
}
.vjs-stop-btn {
  top: 5% !important;
}

.vjs-live>.vjs-control-bar>.vjs-time-divider {
  display: none !important;
}

.vjs-live>.vjs-control-bar>.vjs-duration {
  display: none !important;
}

.video-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.custom-sprite-class {
  background-color: var(--vm-color-two);
}

.video-player {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
}

.video-player-playlist {
  width: 80%;
}

.playlist-container {
  width: 20%;
  height: auto;
  background: var(--vm-color-one);
  overflow: auto;
}

.customMenuButton:hover {
  cursor: pointer;
}

.center-svg-play {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.playlist {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 300px;
  overflow-y: auto;
}
.vjs-next-button,
.vjs-prev-button {
  line-height: 1.67;
  border: none;
  background: transparent !important;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vjs-custom-text-track-display {
  position: absolute;
  bottom: 5em;
  left: 0;
  right: 0;
  top: 0;
  pointer-events: none;

}

.vjs-live-text-cue {
  text-align: center;
  font: 3em sans-serif;
  white-space: pre-line;
  position: absolute;
  bottom: 0%;
  left: 0;
  right: 0;
}

.vjs-live-subtitles {
  color: var(--vm-color-three-08);
  background-color: var(--vm-color-one-08) ;
  position: relative;
  inset: 0px;
  display: inline;
  writing-mode: horizontal-tb;
  unicode-bidi: plaintext;
  font-family: sans-serif;
}
.vjs-live-display{
  color: var(--vm-color-two);
}

@media only screen and (max-width: 650px) {
  .playlist-container {
    width: 100% !important;
    height: 50% !important;
    z-index: 1001;
  }

  .player__cdn {
    display: flex !important;
    flex-direction: column !important;
    overflow-y: auto !important;
  }

  .video-player-playlist {
    height: 50% !important;
    width: 100% !important;
  }

  .video-container {
    display: flex !important;
    flex-direction: column !important;
  }

  .vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
    opacity: 0 !important;
  }

  .vjs-playlist-name {
    font-size: 0.7rem !important;
  }

  .vjs-up-next-text {
    font-size: 1rem !important;
  }

  .video-playlist-card {
    border-bottom: 1px solid var(--vm-color-three-02);
    margin: 0 !important;
  }

  .video-playlist-card .vjs-playlist-title-container {
    position: inherit !important;
    display: flex !important;
    flex-direction: column-reverse !important;
    justify-content: flex-end !important;
  }

  .video-playlist-card img {
    width: 6em !important;
    height: 3em !important;
  }

  .vjs-playlist-duration {
    font-size: 0.6em;
  }

  .center-svg-play {
    display: none !important;
  }

  .video-playlist-card .vjs-playlist-thumbnail {
    display: flex !important;
  }

  .video-playlist-card.vjs-up-next .vjs-up-next-text,
  .video-playlist-card.vjs-selected .vjs-playlist-now-playing-text {
    font-size: 0.7rem !important;
  }

  .video-js .vjs-slides .vjs-big-play-button {
    left: 50% !important;
  }
 .vjs-next-button,
  .vjs-prev-button {
    width: 7% !important;
  }
}

</style>
